// Format currency in Indian Rupees
export const formatCurrency = (value) => {
  if (value === undefined || value === null) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(value);
};

// Format large numbers with K, L, Cr suffixes
export const formatNumber = (value) => {
  if (value === undefined || value === null) return '0';
  
  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  
  if (absValue >= 10000000) { // 1 Crore
    return `${sign}${(absValue / 10000000).toFixed(2)}Cr`;
  } else if (absValue >= 100000) { // 1 Lakh
    return `${sign}${(absValue / 100000).toFixed(2)}L`;
  } else if (absValue >= 1000) {
    return `${sign}${(absValue / 1000).toFixed(1)}K`;
  }
  return `${sign}${absValue.toFixed(0)}`;
};

// Format percentage
export const formatPercent = (value) => {
  if (value === undefined || value === null) return '0%';
  return `${value.toFixed(2)}%`;
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

// Get date range for last N days
export const getDateRange = (days = 30) => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);
  
  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
};
